const ACTIVE_ATTR = 'data-kia-listening';

export interface MicControllerHandlers {
  onActivate: () => void;
  onDeactivate: () => void;
}

/**
 * Establishes the microphone interaction *contract* only: activating the
 * configured mic element toggles listening on/off and reflects that in a
 * data attribute for publisher CSS to hook into. No getUserMedia/audio
 * capture is performed here yet — that lands with actual speech capture.
 */
export class MicController {
  private active = false;

  constructor(
    private readonly element: HTMLElement,
    private readonly handlers: MicControllerHandlers,
    private readonly signal: AbortSignal,
  ) {
    this.element.setAttribute('aria-pressed', 'false');
    this.element.addEventListener('click', this.handleClick, { signal: this.signal });
  }

  private handleClick = (): void => {
    if (this.active) {
      this.deactivate();
    } else {
      this.activate();
    }
  };

  activate(): void {
    if (this.active) return;
    this.active = true;
    this.element.setAttribute(ACTIVE_ATTR, 'true');
    this.element.setAttribute('aria-pressed', 'true');
    this.handlers.onActivate();
  }

  deactivate(): void {
    if (!this.active) return;
    this.active = false;
    this.element.setAttribute(ACTIVE_ATTR, 'false');
    this.element.setAttribute('aria-pressed', 'false');
    this.handlers.onDeactivate();
  }

  isActive(): boolean {
    return this.active;
  }

  destroy(): void {
    this.active = false;
    this.element.removeAttribute(ACTIVE_ATTR);
    this.element.removeAttribute('aria-pressed');
  }
}
